'use client';
import { useEffect } from 'react';
import { useTranslation } from '@/hooks/useTranslation';

// This component applies theme-specific body classes
// on every page render, ensuring inner pages always
// have the correct theme even on direct navigation.
export default function ThemeWrapper({ children }) {
  const { locale } = useTranslation();

  useEffect(() => {
    // One uniform visual theme for every language. Locale only drives text
    // direction (RTL for Arabic) + the lang attribute — never the look.
    // Strip any prior theme-* class generically, then apply the single theme.
    [...document.body.classList].filter(c => c.startsWith('theme-')).forEach(c => document.body.classList.remove(c));
    document.body.classList.add('theme-en');
    document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = locale;
  }, [locale]);

  return children;
}
